var render = function render(){var _vm=this,_c=_vm._self._c;return _c('globalNavigation',{attrs:{"navData":_vm.navData,"navExpanded":_vm.navExpanded}})
}
var staticRenderFns = []

export { render, staticRenderFns }